import { render, staticRenderFns } from "./EditFormTabButton.vue?vue&type=template&id=d19c49c4&scoped=true&"
import script from "./EditFormTabButton.vue?vue&type=script&lang=js&"
export * from "./EditFormTabButton.vue?vue&type=script&lang=js&"
import style0 from "./EditFormTabButton.vue?vue&type=style&index=0&id=d19c49c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c49c4",
  null
  
)

export default component.exports